module.exports = __webpack_public_path__ + "img/grid_layout_1_2.7387098b.svg";